export default __webpack_public_path__ + "static/media/Logomgikm.2f8585f4.svg";